import { render, staticRenderFns } from "./selectPro.vue?vue&type=template&id=5b7a1130&scoped=true&"
import script from "./selectPro.vue?vue&type=script&lang=js&"
export * from "./selectPro.vue?vue&type=script&lang=js&"
import style0 from "./selectPro.vue?vue&type=style&index=0&id=5b7a1130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b7a1130",
  null
  
)

export default component.exports